/**
 * Admin 관리자 환경 — 라우트 admin.preferences.index 와 동기화.
 *
 * index(): `.admin-prefs` 안의 segmented-control 들에 핸들러 바인딩.
 *          테마 카드(`[data-theme-option]`)는 ThemeToggle.ts (initAdminThemeToggle) 가
 *          GlobalApplication 단계에서 이미 일괄 바인딩하므로 여기서 추가 처리 불필요.
 *
 * 뷰: resources/views/admin/pages/preferences/index.php
 * PHP 컨트롤러: app/Controllers/Admin/AdminPreferencesController.php
 */

import { SegmentedControlHandler } from "../components/SegmentedControlHandler";
import { Logger } from "../../utils/Logger";

const CTRL_TAG = "AdminPreferencesController";

export const AdminPreferencesController = {
  index(): void {
    const root = document.querySelector<HTMLElement>(".admin-prefs");
    if (!root) {
      Logger.debug(`${CTRL_TAG}.index: .admin-prefs not found`);
      return;
    }
    SegmentedControlHandler.init(root);
    Logger.debug(`${CTRL_TAG}.index: segmented handler ready`);
  },
};
